import React, { useState } from 'react';
import './BookingBar.css';

const generateTimes = () => {
  const times = ['All Times'];
  for (let h = 13; h <= 22; h++) {
    for (let m = 0; m < 60; m += 15) {
      times.push(`${String(h).padStart(2, '0')}:${m.toString().padStart(2, '0')}`);
    }
  }
  return times;
};

const TimePickerModal = ({ open, onClose, onSelect, selectedTime }) => {
  const times = generateTimes();
  const [currentIdx, setCurrentIdx] = useState(selectedTime === 'All Times' ? 0 : times.indexOf(selectedTime));

  const shift = (delta) => {
    let idx = currentIdx + delta;
    if (idx < 1) idx = 1;
    if (idx >= times.length) idx = times.length - 1;
    setCurrentIdx(idx);
  };

  if (!open) return null;

  return (
    <div className="payment-modal-overlay" onClick={onClose}>
      <div className="payment-modal" style={{width: 400, maxHeight: 600, overflow: 'auto'}} onClick={e => e.stopPropagation()}>
        <div style={{display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom: 16}}>
          <h3 style={{margin:0}}>Time</h3>
          <button className="close-btn" onClick={onClose}>&times;</button>
        </div>
        <div style={{maxHeight: 300, overflowY: 'auto', marginBottom: 16}}>
          {times.map((t, i) => (
            <div key={t} className="dropdown-item" style={{fontWeight: t===selectedTime?'bold':'normal', border: t===selectedTime?'2px solid #222':'1px solid #eee', borderRadius: 8, marginBottom: 4, background: t===selectedTime?'#f5f5f5':'#fff'}}
              onClick={() => {onSelect(t); onClose(); setCurrentIdx(i);}}>{t}</div>
          ))}
        </div>
        <div style={{display:'flex', gap:8, marginBottom:16}}>
          <button className="dropdown-item" onClick={()=>{shift(-2); onSelect(times[Math.max(currentIdx-2,1)]);}}>± 30m</button>
          <button className="dropdown-item" onClick={()=>{shift(-4); onSelect(times[Math.max(currentIdx-4,1)]);}}>± 1h</button>
          <button className="dropdown-item" onClick={()=>{shift(-8); onSelect(times[Math.max(currentIdx-8,1)]);}}>± 2h</button>
        </div>
        <button className="dropdown-item" style={{width:'100%', background:'#f5f5f5', fontWeight:'bold'}} onClick={()=>{onSelect('All Times'); onClose();}}>Search All Times</button>
      </div>
    </div>
  );
};

export default TimePickerModal; 